import React from 'react';
import styled from "styled-components";
import {colors} from "../../maps/colors";
import StepFieldItem from "../StepFieldItem";
import SensorStatus from "../SensorStatus";
import Icn from "../Icn";
import MiniResizer from "./MiniResizer";

const WrapperStyled = styled.div`
  overflow: auto;
  height: calc(100vh - 300px);
`;

const FloorStyled = styled.div`
  background: ${colors.WHITE};
  margin: 5px;
  position: relative;
`;

const CameraStyled = styled.div`
  padding: 0;
  width: 20px;
  height: 20px;
  position: absolute;
`;

const ImageContainer = styled.div`
    position: absolute; 
    overflow: hidden; 
    left: 0; 
    right: 0;
    top: 0;
    bottom: 0;
`;

const CurrentRotateStyled = styled.div`
    position: absolute;
    bottom: 31px;
    color: ${colors.PINK};
    
    &.field{
        bottom: 61px;
    }
`;

const Floor = (props) => {
    const {
        onMouseMove,
        onMouseDown,
        onMouseUp,
        floor_width,
        floor_height,
        show_steps,
        floor_stage_steps,
        show_fields,
        floor_selected_item,
        sensorStatuses,
        check_in_draw_mode,
        s_floor_selected_item,
        setSelectedFactors,
        floor_stage_fields,
        show_camera,
        floor_stage_cameras,
        check_in_rect,
        check_in_display,
        resizeAreaSelected,
        s_resizeAreaSelected,
        check_out_rect,
        check_out_display,
        selected_factors,
        show_knns,
        knns,
        resizeAreaHandle,
        selectedImage
    } = props;


    const { url, rotate, opacity, zoom, scale, vertical, horizontal } = selectedImage;

    const imageStyle = {
        transform: `translate(${horizontal}px, ${vertical}px) rotate(${rotate}deg) scale(${1 + zoom})`,
        height: `${100 + scale}%`,
        opacity
    }

    return (
        <WrapperStyled
            onMouseMove={onMouseMove}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
        >
            <FloorStyled style={{ width: floor_width + 'px', height: floor_height + 'px', overflow: 'hidden' }}>
                {url && (
                    <ImageContainer>
                        <img src={url} style={imageStyle} />
                    </ImageContainer>
                )}
                {
                    show_steps && floor_stage_steps.map((floor_step, idx) => {
                        const isSelected = floor_selected_item === floor_step.sensorId;

                        const sensorStatusData = sensorStatuses[floor_step.sensorId];
                        const status = sensorStatusData?.status;
                        const statusUpdateAt = sensorStatusData?.statusUpdateAt;
                        let rotate = floor_step.rotate || 0;

                        let width = floor_step.sensor.width;
                        let height = floor_step.sensor.height;
                        if (floor_step.rotate === 90 || floor_step.rotate === 270) {
                            width = floor_step.sensor.height;
                            height = floor_step.sensor.width;
                            rotate= 0;
                        }

                        const isMirror = floor_step.isMirror;

                        return (
                            <div
                                key={floor_step.sensorId + idx}
                                onClick={e => {
                                    if (check_in_draw_mode) return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    s_floor_selected_item(floor_step.sensorId);
                                    setSelectedFactors();
                                }}
                            >
                                <StepFieldItem
                                    name={floor_step.sensor.boardId}
                                    variant="elevation"
                                    isCustomMode
                                    isSquare={true}
                                    hideHrAndIcon={true}
                                    type="step"
                                    isSelected={isSelected}
                                    isMuted={floor_step.sensor.mute}
                                    rotate={floor_step.rotate || 0}
                                    style={{
                                        padding: 0,
                                        width: width,
                                        height: height,
                                        position: 'absolute',
                                        top: floor_step.yFactor,
                                        left: floor_step.xFactor,
                                        zIndex: isSelected ? 1 : 0,
                                        transform: `rotate(${rotate}deg)`
                                    }}
                                >
                                    {isMirror && (
                                        <div className="mirror">
                                            <Icn>lowPriorityIcon</Icn>
                                        </div>
                                    )}
                                    {isSelected && (
                                        <CurrentRotateStyled>
                                            {floor_step.rotate || 0}
                                        </CurrentRotateStyled>
                                    )}
                                    <SensorStatus status={status} statusUpdateAt={statusUpdateAt} />
                                </StepFieldItem>
                            </div>
                        );
                    })
                }

                {
                    show_fields && floor_stage_fields.map((floor_field, idx) => {
                        const isSelected = floor_selected_item === floor_field.fieldId;

                        return (
                            <div
                                key={floor_field.fieldId + idx}
                                onClick={e => {
                                    if (check_in_draw_mode) return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    s_floor_selected_item(floor_field.fieldId);
                                    setSelectedFactors();
                                }}
                            >
                                <StepFieldItem
                                    name={floor_field.field.name}
                                    variant="elevation"
                                    isCustomMode
                                    isSquare={true}
                                    type="field"
                                    isSelected={isSelected}
                                    style={{
                                        padding: 0,
                                        width: floor_field.field.width,
                                        height: floor_field.field.height,
                                        position: 'absolute',
                                        top: floor_field.yFactor,
                                        left: floor_field.xFactor,
                                        transform: `rotate(${floor_field.rotate || 0}deg)`,
                                        zIndex: isSelected ? 1 : 0,
                                    }}
                                >
                                    {isSelected && (
                                        <CurrentRotateStyled className="field">
                                            {floor_field.rotate || 0}
                                        </CurrentRotateStyled>
                                    )}
                                </StepFieldItem>
                            </div>
                        );
                    })
                }
                {
                    show_camera && floor_stage_cameras.map((floor_camera, idx) => {
                        const isSelected = floor_selected_item === floor_camera.cameraId;
                        return (
                            <div
                                key={floor_camera.cameraId + idx}
                                onClick={e => {
                                    if (check_in_draw_mode) return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    s_floor_selected_item(floor_camera.cameraId);
                                    setSelectedFactors();
                                }}
                            >
                                <CameraStyled
                                    style={{
                                        top: floor_camera.yFactor - 10 ,
                                        left: floor_camera.xFactor - 10,
                                        transform: `rotate(${floor_camera.rotate || 0}deg)`,
                                        zIndex: isSelected ? 1 : 0
                                    }}
                                >
                                    <Icn style={{ color: isSelected ? colors.GREEN : 'black' }}>camera</Icn>
                                    <div style={{ position: 'absolute', top: 20, whiteSpace: 'nowrap', fontSize: 10, fontWeight: 'bold' }}>
                                        {
                                            floor_camera.camera.name
                                        }
                                    </div>
                                </CameraStyled>
                            </div>
                        );
                    })
                }

                {
                    check_in_rect.length === 2 && check_in_display ? <div
                        onClick={(e) => {
                            e.stopPropagation();
                            if (resizeAreaSelected?.type === 'checkIn') {
                                s_resizeAreaSelected(null);
                            } else {
                                s_resizeAreaSelected({
                                    ...check_in_rect,
                                    type: 'checkIn'
                                });
                            }
                        }}
                        style={{
                            background: resizeAreaSelected?.type === 'checkIn' ? '#ff000059' : '#4285f470',
                            position: 'absolute',
                            top: check_in_rect[0][1],
                            left: check_in_rect[0][0],
                            height: Math.abs(check_in_rect[1][1] - check_in_rect[0][1]),
                            width: Math.abs(check_in_rect[1][0] - check_in_rect[0][0]),
                        }}
                    >
                        {resizeAreaSelected?.type === 'checkIn' && (
                            <MiniResizer
                                onPositionChangeHandle={(pos, isInc) => {
                                    resizeAreaHandle(pos, isInc);
                                }}
                            />
                        )}
                        <div style={{
                            fontSize: 10,
                            textAlign: 'center',
                            position: 'absolute',
                            width: '100%',
                            top: Math.abs(check_in_rect[1][1] - check_in_rect[0][1]) * 0.35
                        }}>check-in
                        </div>
                    </div> : <></>
                }

                {
                    check_out_rect.length === 2 && check_out_display ? <div
                        onClick={(e) => {
                            e.stopPropagation();
                            if (resizeAreaSelected?.type === 'checkOut') {
                                s_resizeAreaSelected(null);
                            } else {
                                s_resizeAreaSelected({
                                    ...check_out_rect,
                                    type: 'checkOut'
                                });
                            }
                        }}
                        style={{
                        background: resizeAreaSelected?.type === 'checkOut' ? '#ff000059' : '#00000050',
                        position: 'absolute',
                        top: check_out_rect[0][1],
                        left: check_out_rect[0][0],
                        height: Math.abs(check_out_rect[1][1] - check_out_rect[0][1]),
                        width: Math.abs(check_out_rect[1][0] - check_out_rect[0][0])
                    }}>
                        {resizeAreaSelected?.type === 'checkOut' && (
                            <MiniResizer
                                onPositionChangeHandle={(pos, isInc) => {
                                    resizeAreaHandle(pos, isInc);
                                }}
                            />
                        )}
                        <div style={{
                            fontSize: 10,
                            textAlign: 'center',
                            position: 'absolute',
                            width: '100%',
                            top: Math.abs(check_out_rect[1][1] - check_out_rect[0][1]) * 0.35
                        }}>check-out
                        </div>
                    </div> : <></>
                }

                {
                    selected_factors.x > 0 && selected_factors.y > 0 && <code style={{ position: 'fixed', bottom: 100, left: 30 }}>
                        x[{selected_factors.x}] y[{selected_factors.y}]
                    </code>
                }

                {show_knns && knns?.map((item, idxx) => {
                    let isValidItem = item.area.xMin && item.area.yMin && item.area.xMax && item.area.yMax;
                    if (!isValidItem) {
                        return null;
                    }
                    return (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                if (resizeAreaSelected?.type === 'knn' && resizeAreaSelected?.index === idxx) {
                                    s_resizeAreaSelected(null);
                                } else {
                                    s_resizeAreaSelected({
                                        ...item,
                                        index: idxx,
                                        type: 'knn'
                                    });
                                }
                            }}
                            key={idxx + item.knnName}
                            style={{
                                background: '#f442af70',
                                position: 'absolute',
                                top: item.area.yMin,
                                left: item.area.xMin,
                                width: Math.abs(item.area.xMax - item.area.xMin),
                                height: Math.abs(item.area.yMax - item.area.yMin)
                            }}>
                            {resizeAreaSelected?.type === 'knn' && resizeAreaSelected?.index === idxx && (
                                <MiniResizer
                                    onPositionChangeHandle={(pos, isInc) => {
                                        resizeAreaHandle(pos, isInc);
                                    }}
                                />
                            )}
                            <div style={{
                                fontSize: 10,
                                textAlign: 'center',
                                position: 'absolute',
                                width: '100%',
                                top: Math.abs(item.area.yMin * 0.35)
                            }}>
                                Index: {idxx} - {item.knnName}
                            </div>
                        </div>
                    );
                })}
            </FloorStyled>
        </WrapperStyled>
    );
};

export default Floor;